import {
  Attribute,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

import { TranslationMap } from '@shared/h5p-translations/walker';

/**
 * Per-language translation overlay of one module. `data` is the walker's flat
 * `"<itemKey>:<fieldName>" -> value` map. One row per (activity, language).
 */
@JsonApiModelConfig({
  type: 'course_activity_translations',
})
export class CourseActivityTranslation extends JsonApiModel {
  @Attribute()
  language!: string;

  @Attribute()
  data!: TranslationMap;

  // Plain writable FK (mirrors the backend resource attribute).
  @Attribute({ serializedName: 'course_activity_id' })
  courseActivityId!: number;

  @Attribute({ serializedName: 'created_at' })
  createdAt!: Date;

  @Attribute({ serializedName: 'updated_at' })
  updatedAt!: Date;
}
